module.exports = "/_next/static/images/prefooter-blog@2x_abd03b99594403383b8c5e0811efe26e.png";